import { LoadScript } from "@react-google-maps/api";

export const GoogleMapsProvider = ({ children }) => {
  return (
    <LoadScript googleMapsApiKey="AIzaSyCJBy-BZ4A7a-k6hWTL6QUkaR7kY00dGN8" libraries={["places"]}>
      {children}
    </LoadScript>
  );
};
